/**
 * Main page of Automation tab first page the customer sees
 */

define(function (require) {
    "use strict";

    var template = require("automation-templates/landingpage.tmpl");
    var LandingpageView = {};

    LE.module('LEAutomation', function (LEAutomation, LE, Backbone, Marionette, $, _) {
        LandingpageView = Marionette.ItemView.extend({
            template: template,
            className: 'automation-landing-page',
            events: {
                "click #button-bot-platform": "_showBotPlatform",
                "click #button-conv-builder": "_showConvBuilder",
            },

            initialize: function (options) {
                this.$el = options.el;
                this.model = LEAutomation.contextModel;
            },

            onRender: function(){
                $(this.$el).append(this.el);
            },

            _showBotPlatform: function () {
                LEAutomation.router.navigate('bot-platform');
            },

            _showConvBuilder: function () {
                LEAutomation.router.navigate('conversation');
            }
        });
    });

    return LandingpageView;
});
